import styled from "@emotion/styled";
import { Grid2 } from "@mui/material";

const GridContainer = styled(Grid2)`
  flex-direction: column;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    flex-direction: row;
  }
`;

const HiddenShownBlock = styled.div`
  display: block;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    display: none;
  }
`;

const ContentBox = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    display: none;
  }
`;

const GridItem = styled(Grid2, {
  shouldForwardProp: prop =>
    prop !== "isHeroToggle" && prop !== "isToggleShow" && prop !== "isShow",
})`
  padding: 14px 12px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.secondary.stroke};

  @media (max-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    cursor: ${({ isHeroToggle }) => (isHeroToggle ? "pointer" : "default")};

    ${({ isToggleShow }) =>
      isToggleShow &&
      `
        display: none;
      `}

    ${({ isShow }) =>
      isShow &&
      `
        display: block;
        background: ${({ theme }) => theme.colors.background};
      `}
  }
`;

export { GridContainer, HiddenShownBlock, ContentBox, GridItem };
